<template>
  <b-form-group
    :label="label"
    :label-for="name"
  >
    <validation-provider
      #default="{ errors }"
      :name="label"
      :rules="getRules"
    >
      <b-form-input
        :id="name"
        v-model="value"
        :state="errors.length > 0 ? false:null"
        :placeholder="label"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormInput, BFormGroup,
} from 'bootstrap-vue'
import Base from './Base.vue'

export default {
  name: 'OwnerUiType',
  components: {
    ValidationProvider,
    BFormInput,
    BFormGroup,
  },
  extends: Base,
}
</script>

<style scoped>

</style>
